module.exports = (__webpack_require__(4))(52);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/warning/browser.js from dll-reference vendorProd_library
// module id = 1393
// module chunks = 42